module.exports = "/assets/order-personal-details.png?zRIV2zG";